import { faSliders } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "@/components/ui/dropdown";

interface CarListFilterProps {
  numberOfAvailable: number;
}

const CarListFilter = ({numberOfAvailable}: CarListFilterProps) => {
  return (
    <div className="md:grid md:grid-cols-7 md:items-center mb-2">
      <p className="md:col-span-2 mb-2 md:mb-0 text-grey-500">{numberOfAvailable} available</p>
      {/* <Dropdown id="transmission" optionList={["Transmission"]} className="hidden md:block" />
      <Dropdown id="seat" optionList={["Seat"]} className="hidden md:block" />
      <Dropdown id="vehicleType" optionList={["Vehicle Type"]} className="hidden md:block" />
      <Dropdown id="priceRange" optionList={["Price Range"]} className="hidden md:block" />
      <p className="text-green-600 border-2 border-green-600 text-center rounded-md py-2 w-24">
        <FontAwesomeIcon icon={faSliders} /> Filters
      </p> */}
    </div>
  );
};

export default CarListFilter;
